import { sendAliveOnevehicleToLobby } from "../../../utils/sendData";

export function startAudioMonitor(
  stream: MediaStream,
  vehicleCC: string,
  onevehicleCC: string,
  lobbyCC: string,
  analyzeFreq: number,
  sendData: (msg: object) => void
) {
  const SampleNum = 16384;
  const SamplingRate = 48000;
  const AnalyzeFreq = analyzeFreq;
  const AnalyzeInterval = 3000;
  const AlertThreshold = 2;
  const AlertTime = 9000;
  const context = new AudioContext();
  const source = context.createMediaStreamSource(stream);
  const processor = context.createScriptProcessor(SampleNum, 2, 2);

  source.connect(processor);
  processor.connect(context.destination);

  let count = 0;
  let alertCount = 0;
  let aud = 0;

  const sinBuffer = new Float32Array(SamplingRate);
  const cosBuffer = new Float32Array(SamplingRate);
  for (let i = 0; i < SamplingRate; i++) {
    sinBuffer[i] = Math.sin((2 * Math.PI * AnalyzeFreq * i) / SamplingRate);
    cosBuffer[i] = Math.cos((2 * Math.PI * AnalyzeFreq * i) / SamplingRate);
  }

  const sendTelegram = (aud: number) => {
    sendData(sendAliveOnevehicleToLobby(onevehicleCC, lobbyCC, aud, vehicleCC.slice(-4)));
  };

  processor.onaudioprocess = (evt) => {
    const input = evt.inputBuffer.getChannelData(0);
    let sinSum = 0;
    let cosSum = 0;
    let sum = 0;

    for (let i = 0; i < SampleNum; i++) {
      sinSum += input[i] * sinBuffer[count % SamplingRate];
      cosSum += input[i] * cosBuffer[count % SamplingRate];
      count++;

      if (count === (SamplingRate * AnalyzeInterval) / 1000) {
        count = 0;
        sendTelegram(aud);
      }
    }
    sum = Math.sqrt(sinSum ** 2 + cosSum ** 2);

    if (sum > AlertThreshold) {
      alertCount = 0;
      aud = 1;
    } else if (aud === 1) {
      alertCount += SampleNum;
      if (alertCount > SamplingRate * AlertTime / 1000) {
        aud = 0;
      }
    }
  };

  return {
    stop: () => {
      processor.disconnect();
      source.disconnect();
      context.close();
    },
  };
}
